import 'gw-portals-policytransaction-common-angular';
import 'gw-portals-viewmodel-js';
import 'angularRouter';
import RouteConfig from './config/RouteConfig';

import BOPLocationDirective from './locationsAndBuildings/directives/cpp-location-directive/CPPLocationDirective';
import BOPLocationHeader from './locationsAndBuildings/directives/cpp-location-directive/CPPLocationHeader';

import BOPBuildingDirective from './locationsAndBuildings/directives/cpp-building-directive/CPPBuildingDirective';
import BOPBuildingHeader from './locationsAndBuildings/directives/cpp-building-directive/CPPBuildingHeader';

import BOPConfirmation from './locationsAndBuildings/directives/cpp-confirmation-directive/CPPConfirmationDirective';

import BOPGeneralCoverages from './coverages/general';
import BOPAdditionalCoverages from './coverages/additional';

export default angular.module('ama-portals-cpp-components-angular', ['edge.transaction.common.app']).config(['$stateProvider', 'state_plugin_config', function ($stateProvider, RootStateConfig) {
    var states = new RouteConfig(RootStateConfig);
    for (var stateName in states) {
        if (states.hasOwnProperty(stateName)) {
            $stateProvider.state(stateName, states[stateName]);
        }
    }
}]).directive('amaQnbCppLocation', BOPLocationDirective).directive('amaQnbCppBuilding', BOPBuildingDirective).directive('amaQnbCppLocationHeader', BOPLocationHeader).directive('amaQnbCppBuildingHeader', BOPBuildingHeader).directive('amaQnbCppConfirmation', BOPConfirmation).component('amaCppGeneralCoverages', BOPGeneralCoverages).component('amaCppAdditionalCoverages', BOPAdditionalCoverages);


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/ama/cpp/components/module.js
// module id = 820
// module chunks = 0